import { Component, OnInit } from '@angular/core';
import { LiftParameterSettingsDetail } from '../../models/list-parameter-settings-detail';
import { LoginService } from 'src/app/user/services/login.service';
import { LiftParameterSettingsService } from '../../services/lift-parameter-settings.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { NotificationType } from 'src/app/core/models/ui-notification.model';

@Component({
  selector: 'app-lift-parameter-settings-detail',
  templateUrl: './lift-parameter-settings-detail.component.html',
  styleUrls: ['./lift-parameter-settings-detail.component.css']
})
export class LiftParameterSettingsDetailComponent implements OnInit {
  liftParameterSettings: LiftParameterSettingsDetail;

  form = new FormGroup({});
  langs = [
    { 'lang': 'cs', 'title': 'Česky' },
    { 'lang': 'en', 'title': 'Anglicky' },
    { 'lang': 'de', 'title': 'Německy' }
  ];

  types = [
    { 'val': 1, 'title': 'String' },
    { 'val': 2, 'title': 'Int' },
    { 'val': 3, 'title': 'Enum' },
    { 'val': 4, 'title': 'IO' }
  ];

  readonly = [
    { 'val': 1, 'title': 'Ano' },
    { 'val': 0, 'title': 'Ne' }
  ];
  jsonError = false;

  napovedaInt = 'Příklad dat pro Int: { "default": 5,  "min": 0, "max": 20 }';
  napovedaString = 'Příklad dat pro String: { "default": "test",  "length": 4 }';
  napovedaEnum = 'Příklad dat pro Enum: [ "SIMPLEX", "DUPLEX"]';
  napovedaIO = 'Příklad dat pro IO: ["JÍZDA NAHORU", "JÍZDA DOLU"]';
  napovedaType = 1;

  constructor(
    private route: ActivatedRoute,
    private loginService: LoginService,
    private liftParameterSettingsService: LiftParameterSettingsService,
    private entityListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService
  ) { }

  ngOnInit() {
    this.liftParameterSettings = this.route.snapshot.data.liftParameterDetail;

    const type = this.types.filter(item => item.val === this.liftParameterSettings.type)[0];
    let isRead = this.readonly[0];
    if (this.liftParameterSettings.isReadonly) {
      isRead = this.readonly.filter(item => item.val == 1)[0];
    } else {
      isRead = this.readonly.filter(item => item.val == 0)[0];
    }
    
    const defaultLang = this.liftParameterSettings.language.filter(item => item.twoLetterISOLanguageName === 'cs')[0];
    this.napovedaType = type.val;

    this.form.addControl('code', new FormControl(this.liftParameterSettings.code));
    this.form.addControl('lang', new FormControl(this.langs[0], Validators.required));
    this.form.addControl('description', new FormControl(defaultLang.description, Validators.required));
    this.form.addControl('type', new FormControl(type, Validators.required));
    this.form.addControl('values', new FormControl(this.liftParameterSettings.values, Validators.required));
    this.form.addControl('isReadonly', new FormControl(isRead, Validators.required));

    this.form.controls['lang'].disable();
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onTypeChange() {
    const type = this.form.get('type').value.val;
    this.napovedaType = type;
  }

  onSubmit(modal: ModalComponent) {
    if (this.form.valid && this.loginService.isSuperadmin()) {
      const csLang = this.liftParameterSettings.language.filter(item => item.twoLetterISOLanguageName === 'cs')[0];
      const enLang = this.liftParameterSettings.language.filter(item => item.twoLetterISOLanguageName === 'en')[0];
      const deLang = this.liftParameterSettings.language.filter(item => item.twoLetterISOLanguageName === 'de')[0];

      const lookupLang = [
        { id: csLang.id, twoLetterISOLanguageName: 'cs', title: this.form.get('description').value, description: this.form.get('description').value },
        { id: enLang.id, twoLetterISOLanguageName: 'de', title: this.form.get('description').value, description: this.form.get('description').value },
        { id: deLang.id, twoLetterISOLanguageName: 'en', title: this.form.get('description').value, description: this.form.get('description').value }
      ];

      this.liftParameterSettingsService.update({
        id: this.liftParameterSettings.id,
        code: this.form.get('code').value,
        language: lookupLang,
        type: this.form.get('type').value.val,
        values: this.form.get('values').value,
        isReadonly: ((this.form.get('isReadonly').value.val == 1) ? true : false)
      }).subscribe(() => {
        this.entityListRefresh.refresh('lift-parameter-settings');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Parametr byl aktualizován'
        });
        modal.closeModal(null);
        },
        error => {
          console.log(error);
          this.jsonError = true;
        });
    }
  }
}
